import { render, staticRenderFns } from "./DocumentGeneration.vue?vue&type=template&id=0c7d3d06&scoped=true&"
import script from "./DocumentGeneration.vue?vue&type=script&lang=ts&"
export * from "./DocumentGeneration.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentGeneration.vue?vue&type=style&index=0&id=0c7d3d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7d3d06",
  null
  
)

export default component.exports